module.exports = __webpack_public_path__ + "img/手机端商品1.94b3e911.png";